/**
 * Contract wording shown in the contract preview (the page's preview modal
 * and the contract wizard's "Granska & signera"). Kept as fixed Swedish text:
 * it is agreement wording the customer signs, not UI copy.
 *
 * Note: the signed PDF (etappio-api signing.service.ts) currently uses a
 * shorter ROT sentence; aligning the two is a separate legal decision.
 */
export const ROT_INFORMATION_TEXT =
  'ROT-beloppen är information och instruktion för insättningen. Det avtalade priset är hela beloppet före ROT. Hantverkaren ansvarar för att ROT är korrekt och för hanteringen mot Skatteverket.';

export const ROT_CUSTOMER_LIABILITY_TEXT =
  'ROT-avdraget är preliminärt. Om Skatteverket helt eller delvis inte medger utbetalning till hantverkaren ska beställaren, mot faktura, betala motsvarande belopp direkt till hantverkaren. Detta gäller inte om den uteblivna utbetalningen beror på att hantverkaren inte har fullgjort sina skyldigheter. Om Skatteverket senare bedömer att beställaren saknar rätt till hela den slutliga skattereduktionen kan beställaren dessutom bli återbetalningsskyldig till Skatteverket.';
